import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Configuracion/configuracion';
import Configuracion from './Configuracion';

const mstp = state => {
    return {...state.configuracion}
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(Configuracion)
